import {API} from "aws-amplify";

const getRecentCalls = async ({queryKey}) => {
    // eslint-disable-next-line
    const [_key, {start, pageSize, from, to, lat, lng, sourceIdentifier2}] = queryKey;
    const fromDateEpoch = from ? from.getTime()/1000 : "";
    const toDateEpoch = to ? to.getTime()/1000 : "";
    // Omit the optional parameter entirely for the existing single-call workflow.
    const groupQuery = sourceIdentifier2 ? `&sourceIdentifier2=${encodeURIComponent(sourceIdentifier2)}` : "";
    return await API.get("dev-psap",
        `/calls?start=${start}&pageSize=${pageSize}&from=${fromDateEpoch}&to=${toDateEpoch}&lat=${lat}&lng=${lng}${groupQuery}`,
        null);
};

const getCallDetails = async ({queryKey}) => {
    // eslint-disable-next-line
    const [_key, {callUuid}] = queryKey;
    return await API.get("dev-psap", `/call/${callUuid}`, null);
};

export {getCallDetails, getRecentCalls};
// Fetch all result pages separately from the sidebar pagination.
export const getGroupCalls = async ({queryKey}) => {
    const [, filters] = queryKey;
    // Deduplicate by call UUID if a call is repeated across pages during a refresh.
    const calls = new Map();
    let start = 0;
    while (true) {
        const page = await getRecentCalls({queryKey: ['get-calls', {...filters, start, pageSize: 250}]});
        for (const call of page.calls) calls.set(call.callUuid, call);
        // Advance by rows actually returned, rather than assuming a full page.
        // An empty page also ends retrieval if the result count changed mid-fetch.
        start += page.calls.length;
        if (!page.calls.length || start >= page.count) break;
    }
    return [...calls.values()];
};
